import type { MarketResponseDto } from "Infrastructure/Api/Api";
import {
	createFormActiveStepAtom,
	createFormMarketId,
	createFormMarketUrlPath,
} from "Market/Atom/createFormAtoms";
import { GeneralForm } from "Market/Components/Form/GeneralForm";
import { useAtom } from "jotai";

export function GeneralFormWidget() {
	const [activeStep, setActiveStep] = useAtom(createFormActiveStepAtom);
	const [_, setMarketId] = useAtom(createFormMarketId);
	const [__, setMarketUrlPath] = useAtom(createFormMarketUrlPath);

	const handleSuccessResponse = (response: MarketResponseDto) => {
		setMarketId(response.id);
		setMarketUrlPath(response.urlPath);
		setActiveStep(activeStep + 1);
	};

	return <GeneralForm onSuccess={handleSuccessResponse} />;
}
